import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { LangContext } from '../../context/lang-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import NoResults from '../../components/NoResults/NoResults'
import moment from "moment";
import { NavigationContext } from '../../context/navigation-context'
import SearchFilter from '../../components/Filter/SearchFilter'

const PZS = () => {
  const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(null);
  const { TRL_Pack } = useContext(LangContext)
  const { fetchMssqlApi } = useFetch()
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)

  const { setHeaderData } = useContext(NavigationContext)

  const [PZS, setPZS] = useState(null)

  const defaultFilter = {
    name: "PZS",
    page: 1,
    rowsPerPage: 50,
    sortBy: "none",
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    warehouseId: null,
    warehouseName: "",
    userId: null,
    userName: "",
  }

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    WarehouseOperationFullName: "DESC",
    WarehouseOperationTypeName: "ASC",
    MachineFullName: "ASC",
    RelatedDoc: "DESC",
    WarehouseInventoryFullName: "ASC",
    IssuedOn: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    getPZS(next);
  };

  useEffect(() => {
      const handleResize = () => {
      setWindowHeight(window.innerHeight)

      const screenHeight = window.innerHeight
      const reservedSpace = 350
      const visibleRows = Math.floor((screenHeight - reservedSpace) / 40)

      setFilter(prev => ({
          ...prev,
          rowsPerPage: visibleRows > 50 ? 50 : visibleRows,
      }))
      }

      window.addEventListener("resize", handleResize)
      handleResize()

      return () => window.removeEventListener("resize", handleResize)
  }, [])

  const search = (f) => {
    getPZS(f || filter)
  }

  const getPZS = (f = filter) => {
    fetchMssqlApi('pz-pzs', {
      method: "POST",
      hideNotification: true,
      data: {
        fromCreateDateTime: f.dateTimeRangeFrom,
        toCreateDateTime: f.dateTimeRangeTo,
        warehouseId: f.warehouseId,
        createUserId: f.userId,
        sortBy: f?.sortBy,
      },
    }, response => {
      setPZS(response);
      console.log(response)
    })
  }


  useEffect(() => {
    getPZS()
    setHeaderData({
      text: TRL_Pack.pz.pzs
    });
  }, [])

  useEffect(() => localStorage.setItem('pzsFilter', JSON.stringify(filter)), [
    filter
  ])


  const sortRows = (a, b) => {
    /*const [id, order, type] = filter.sortBy.split(' | ')
    const col = Object.keys(salesdoc[0])[Number(id) - 1]

    if (a[col] === b[col]) return 0
    else if (a[col] === null) return 1
    else if (b[col] === null) return -1

    let valueA, valueB
    if (type === 'text' || type === 'date') {
      valueA = a[col].toUpperCase()
      valueB = b[col].toUpperCase()
    } else if (type === 'price') {
      valueA = Number(a[col].replace(',', ''))
      valueB = Number(b[col].replace(',', ''))

      // Number().toLocaleString(undefined, {minimumFractionDigits: 2}) num => str '1 245 151,50'
    } else return 0

    if (order === 'asc') return valueA < valueB ? -1 : 1
    else return valueA < valueB ? 1 : -1
    */
  }

  const getUI = () => {
    if (PZS != null) {
      let temp = JSON.parse(JSON.stringify(PZS));

      return (
        <div>
          <div>
            <SearchFilter
                filterName="PZS"
                defaultFilter={defaultFilter}
                onFilterChange={(f) =>
                  setFilter((prev) => ({ ...prev, ...f }))
                }
                onSettingsChange={(s) =>
                  setSettingsFilter((prev) => ({ ...prev, ...s }))
                }
                search={search}
                totalCount={PZS.slice(
                          (filter.page - 1) * filter.rowsPerPage,
                          filter.page * filter.rowsPerPage
                        ).length}
                dataList={PZS}
                forNow
            />
            <div className="border">
              <div className="overflow-auto custom-scroll" 
                  style={{
                    maxHeight: `${windowHeight - 146}px`,
                    overflowY: "auto",
                  }}>
                {PZS.length ? (
                  <table className="table table-striped">
                    <thead>
                      <tr className="text-center headers-color">
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("WarehouseOperationFullName")}
                        >
                          Nr dokumentu <br />Czas zapisu, Źródło{arrow("WarehouseOperationFullName")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("WarehouseOperationTypeName")}
                        >
                          Typ dokumentu{arrow("WarehouseOperationTypeName")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("MachineFullName")}
                        >
                          Maszyna / Magazyn{arrow("MachineFullName")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("RelatedDoc")}
                        >
                          Dokument powiązany{arrow("RelatedDoc")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("WarehouseInventoryFullName")}
                        >
                          Zamknięty{arrow("WarehouseInventoryFullName")}
                        </th>
                        <th
                          className='align-middle'
                          style={{ cursor: "pointer", userSelect: "none" }}
                          onClick={() => handleHeaderSort("IssuedOn")}
                        >
                          Data / czas wystawienia{arrow("IssuedOn")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {PZS
                        .slice(
                          (filter.page - 1) * filter.rowsPerPage,
                          filter.page * filter.rowsPerPage
                        )
                        .map((entry, idx) => (
                          <tr key={idx} className='text-center'>
                            <td className="">
                              <div className='d-flex flex-column justify-content-center align-items-center'>
                              <Link to={`/${String(entry.WarehouseOperationFullName).split(/[^A-Z]/g)[0].toLocaleLowerCase() || "pz"}/${entry.WarehouseOperationId}`} className="btn text-nowrap btn-sm btn-outline-info">{entry.WarehouseOperationFullName}</Link>
                                <div className="btn text-wrap">{entry.Created}</div>
                              </div>
                            </td>
                            <td><div className="d-flex flex-column justify-content-center align-items-center">{entry.WarehouseOperationTypeName}</div></td>
                            <td><div className='d-flex flex-column justify-content-center align-items-center'>
                              {entry.MachineFullName !== null && (<Link to={`/machine/${entry.MachineId}`} className="btn text-nowrap btn-sm btn-outline-link">{entry.MachineFullName}</Link>)}
                              <div className="text-nowrap">{entry.WarehouseFullName}</div>
                            </div>
                            </td>
                            <td><div className='d-flex flex-column justify-content-center align-items-center'>
                              {entry.ToWarehouseOperationId !== null && (
                              <Link to={`/${String(entry.WarehouseOperationFullName).split(/[^A-Z]/g)[0].toLocaleLowerCase() || "pz"}/${entry.ToWarehouseOperationId}`} className="btn text-nowrap btn-sm btn-outline-info">{entry.RelatedDoc}</Link>
                              )}
                            </div></td>
                            <td className="">
                              <div className='d-flex flex-column justify-content-center align-items-center'>
                                {entry.WarehouseInventoryId !== null && (<Link to={`/in/${entry.WarehouseInventoryId}`} className="btn text-nowrap btn-sm btn-outline-secondary">{entry.WarehouseInventoryFullName}</Link>)}
                              </div>
                            </td>
                            <td><div className='d-flex flex-column justify-content-center align-items-center'>
                              {entry.IssuedOn}
                            </div></td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <NoResults />
                )
                }
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  return (
    <>
      <div>
        {getUI()}
      </div>
    </>
  )
}

export default PZS;